import { isEmpty } from 'lodash';
import { useState } from 'react';

/**
 * rowId: { prop: isValid }
 */
export type PricingRowValidationState = {
    [key in string]: {
        [key in string]: boolean;
    };
};

export default () => {
    const [state, setState] = useState<PricingRowValidationState>({});

    const setIsRowValid = (rowId, prop, isValid) => {
        setState((prevState) => {
            const row = prevState[rowId] || {};
            row[prop] = isValid;
            return { ...prevState, [rowId]: row };
        });
    };

    const isRowValid = (rowId) => {
        return !isEmpty(state[rowId]) && !Object.values(state[rowId]).includes(false);
    };

    return { setIsRowValid, isRowValid };
};
